export default __webpack_public_path__ + "static/media/116t.32db6a42.jpg";